export default __webpack_public_path__ + "static/manifold_b.30ce48b18c1d88ee5bb55cd7109c2b70.svg";